import { u as useStateManager } from './useStateManager-68425271.esm.js';
import _extends from '../../@babel/runtime/helpers/esm/extends.js';
import * as React from 'react';
import { forwardRef } from 'react';
import { S as Select$1 } from './Select-54ac8379.esm.js';
export { c as createFilter, d as defaultTheme } from './Select-54ac8379.esm.js';
import 'react-dom';

var StateManagedSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React.createElement(Select$1, _extends({
    ref: ref
  }, baseSelectProps));
});

var Select = StateManagedSelect;

export { Select as default, useStateManager };
